// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"2b082965","28":"6e569e99","384":"76b6413b","484":"12416e27","610":"41246d2d","708":"d35a6f77","994":"2b082965"}[chunkId] + ".chunk.css";
};